import { FunctionComponent } from 'react';

import BoolDropdown from './BoolDropdown';
import { Wrapper, WrapperProps } from './Wrapper';

interface DropdownProps extends WrapperProps {
  options: object;
  required?: boolean;
}

export const Dropdown: FunctionComponent<DropdownProps> = (props) => {
  return (
    <Wrapper {...props}>
      {Object.entries(props.options).map(
        ([key, value]: [string, string], index: number) => (
          // eslint-disable-next-line react-x/no-array-index-key -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
          <option key={index} value={key}>
            {value}
          </option>
        ),
      )}
    </Wrapper>
  );
};

export { BoolDropdown, Wrapper };
